module.exports = __webpack_public_path__ + "static/img/slot.2a2a8c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/slot.png
// module id = OiXI
// module chunks = 1